import * as React from 'react';

import { Underground } from '../../../../../../components/Field/common/LocationField';
import { IUnderground } from '../../../../../../types/offer';

export const UndergroundContainer = ({ underground }: { underground: IUnderground }): React.JSX.Element => {
  return <Underground name={underground.name} color={underground.lineColor ? `#${underground.lineColor}` : ''} />;
};
